import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React from 'react';
const NotifyContainer = () => (React.createElement(React.Fragment, null,
    React.createElement(ToastContainer, { position: "bottom-right", autoClose: 5000, hideProgressBar: false, newestOnTop: false, closeOnClick: false, rtl: false, pauseOnFocusLoss: false, draggable: false, pauseOnHover: false, theme: "light" })));
export default NotifyContainer;
